import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { ScheduleStepBooking } from '@booking/pages/liveqHome/liveqSteps/components/forms/scheduleStep/bookingStep';
const LiveqTelehealth = () => {
    return (_jsx(ScheduleStepBooking, {}));
};
export default observer(LiveqTelehealth);
